import { Directive } from '@angular/core';
import { NG_VALIDATORS, FormControl, Validator, ValidationErrors } from '@angular/forms';
import { BookService } from './../../services/book.service';

@Directive({
  selector: '[ean-13-validator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: Ean13ValidatorDirective, multi: true }]
})
export class Ean13ValidatorDirective implements Validator {

  constructor(private bookService: BookService) { }

  validate(c: FormControl): ValidationErrors {
    // console.log('ean-13-validator', c.value);
    const isValid = c.value && this.bookService.checkEan(c.value);
    const message = {
      'ean13': {
        'message': 'EAN-13 non valido'
      }
    };
    return isValid ? null : message;
  }



}



// WEBPACK FOOTER //
// ./src/app/helpers/validators/ean13-validator.directive.ts